import { Injectable } from '@angular/core';
import { Paginador } from '../api/dto/paginacao/paginador';
import { ComissaoProfissional } from '../api/dto/comissao-profissional';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UrlServidor } from '../util/url-servidor';

@Injectable({
    providedIn: 'root'
})
export class ComissaoService {

    private url: string = UrlServidor.URL_BASE + 'comissoes';

    constructor(private http: HttpClient) { }


    listarPorEmpresa(empresaId?: number, numeroPagina?: number, tamanhoPagina?: number,
        ordenacao?: string, filtroDataInicio?: Date, filtroDataFim?: Date,
        codigoTipoComissao?: number, contratoId?: number, profissionalId?: number):
        Observable<Paginador<ComissaoProfissional>> {


        let params = new HttpParams();
        if (tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if (ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if (filtroDataInicio) {
            params = params.set('dataInicio', filtroDataInicio.toISOString());
        }
        if (filtroDataFim) {
            params = params.set('dataFim', filtroDataFim.toISOString());
        }
        if (codigoTipoComissao) {
            params = params.set('codigoTipoComissao', codigoTipoComissao);
        }
        if (contratoId) {
            params = params.set('contratoId', contratoId);
        }
        if (profissionalId) {
            params = params.set('profissionalId', profissionalId);
        }

        return this.http.get<Paginador<ComissaoProfissional>>(`${this.url}/empresa/${empresaId}/pagina/${numeroPagina}`, { params });
    }

    obterRelatorio(empresaId?: number, filtroDataInicio?: Date, filtroDataFim?: Date,
        codigoTipoComissao?: number, contratoId?: number, profissionalId?: number): Observable<Blob> {


        let params = new HttpParams();

        if (filtroDataInicio) {
            params = params.set('dataInicio', filtroDataInicio.toISOString());
        }
        if (filtroDataFim) {
            params = params.set('dataFim', filtroDataFim.toISOString());
        }
        if (codigoTipoComissao) {
            params = params.set('codigoTipoComissao', codigoTipoComissao);
        }
        if (contratoId) {
            params = params.set('contratoId', contratoId);
        }
        if (profissionalId) {
            params = params.set('profissionalId', profissionalId);
        }

        return this.http.get(`${this.url}/empresa/${empresaId}/relatorio`, { params: params, responseType: 'blob' });
    }
}
